import { render, staticRenderFns } from "./NzContentLicenceAgreementContent.vue?vue&type=template&id=1d0ca437"
import script from "./NzContentLicenceAgreementContent.vue?vue&type=script&lang=js"
export * from "./NzContentLicenceAgreementContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports